export default __webpack_public_path__ + "static/media/logo-with-name.36441401.png";